export {
  LABEL_PRINT_ROTATIONS,
  isLabelPrintRotation,
  rotateLabelClockwise,
  rotateLabelCounterClockwise,
  type LabelPrintRotation,
} from "@itaas/label-print";

import { isLabelPrintRotation, type LabelPrintRotation } from "@itaas/label-print";

const STORAGE_KEY = "hospitol.labelPrintRotation";

export function loadSavedLabelRotation(): LabelPrintRotation {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const n = Number(raw);
    if (isLabelPrintRotation(n)) return n;
  } catch {
    /* ignore */
  }
  return 0;
}

export function saveLabelRotation(rotation: LabelPrintRotation): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(rotation));
  } catch {
    /* ignore */
  }
}
